import { createModel } from "@rematch/core";

import * as api from "../api";
import { AuthState } from "../types/index";
import { RootModel } from ".";

const initialState = {
  password: "",
  role: "",
  token: localStorage.getItem("login"),
  username: "",
};

export const auth = createModel<RootModel>()({
  state: initialState as AuthState,
  reducers: {
    loginFail(state, error: string) {
      return { ...state, error };
    },
    loginSuccess(state, token) {
      return { ...state, error: undefined, password: "", role: "", token };
    },
    signout(state) {
      localStorage.removeItem("login")
      return { ...state, token: null, error: undefined };
    },
    changePassword(state, password) {
      return { ...state, password };
    },
    changeUsername(state, username) {
      return { ...state, username };
    },
  },
  effects: (dispatch) => ({
    async login({
      username,
      password,
    }: {
      username: string;
      password: string;
    }) {
      console.log("login()");
      try {
        const token = await api.login(username, password);
        localStorage.setItem("login", token);
        dispatch.auth.loginSuccess(token);
      } catch (error) {
        dispatch.auth.loginFail(error || "unknown");
      }
    },
  }),
});



// WEBPACK FOOTER //
// ./src/models/auth.ts